<template>
  <div class="locations-asking">
    <h3>Demandes</h3>
    <div class="table-responsive">
      <div id="basicTable_wrapper"
           class="dataTables_wrapper form-inline no-footer">
        <table class="table table-hover dataTable no-footer"
               id="basicTable"
               role="grid">
          <tbody>
            <locations-asking-item v-for="n in 7"
                                   :key="n"></locations-asking-item>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .locations-asking {
    margin: 15px 0 0 15px;
    min-width: 300px;
  }
</style>

<script type="text/babel">
  import LocationsAskingItem from './LocationsAskingItem.vue'
  export default {
    components: {
      LocationsAskingItem
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/LongTermLocationsList/LocationsAsking.vue